import { useState } from 'react';
import Layout from '../../../components/feature/Layout';

interface Followup {
  id: string;
  client: string;
  opportunity: string;
  type: 'Llamada' | 'Reunión' | 'Email';
  description: string;
  responsible: string;
  dueDate: string;
  status: 'Pendiente' | 'Completado' | 'Vencido';
}

export default function FollowupsPage() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedFollowup, setSelectedFollowup] = useState<Followup | null>(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');

  const followups: Followup[] = [
    { id: 'SEG-001', client: 'Importadora del Pacífico S.A.', opportunity: 'Importación Maquinaria Industrial', type: 'Llamada', description: 'Seguimiento sobre cotización enviada', responsible: 'Juan Delgado', dueDate: '2024-02-05', status: 'Pendiente' },
    { id: 'SEG-002', client: 'Textiles Modernos S.A.', opportunity: 'Exportación Textiles', type: 'Reunión', description: 'Presentación de propuesta comercial', responsible: 'María López', dueDate: '2024-02-08', status: 'Pendiente' },
    { id: 'SEG-003', client: 'Alimentos Premium', opportunity: 'Importación Alimentos', type: 'Email', description: 'Envío de documentación requerida', responsible: 'Carlos Méndez', dueDate: '2024-02-03', status: 'Completado' },
    { id: 'SEG-004', client: 'Exportadora Central', opportunity: 'Exportación Café', type: 'Llamada', description: 'Aclaración de dudas sobre servicios', responsible: 'Ana Rodríguez', dueDate: '2024-02-01', status: 'Vencido' },
    { id: 'SEG-005', client: 'Global Trade Solutions', opportunity: 'Importación Electrónicos', type: 'Reunión', description: 'Negociación de tarifas', responsible: 'Juan Delgado', dueDate: '2024-02-10', status: 'Pendiente' },
    { id: 'SEG-006', client: 'Comercial Atlántico', opportunity: 'Exportación Frutas', type: 'Email', description: 'Confirmación de inicio de operación', responsible: 'María López', dueDate: '2024-02-04', status: 'Completado' },
    { id: 'SEG-007', client: 'Importadora del Pacífico S.A.', opportunity: 'Importación Repuestos', type: 'Llamada', description: 'Seguimiento post-cierre', responsible: 'Carlos Méndez', dueDate: '2024-02-06', status: 'Pendiente' },
    { id: 'SEG-008', client: 'Textiles Modernos S.A.', opportunity: 'Exportación Químicos', type: 'Reunión', description: 'Revisión de contrato', responsible: 'Ana Rodríguez', dueDate: '2024-02-12', status: 'Pendiente' },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Pendiente': return 'bg-yellow-100 text-yellow-700';
      case 'Completado': return 'bg-green-100 text-green-700';
      case 'Vencido': return 'bg-red-100 text-red-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'Llamada': return 'ri-phone-line';
      case 'Reunión': return 'ri-calendar-event-line';
      case 'Email': return 'ri-mail-line';
      default: return 'ri-file-line';
    }
  };

  const filteredFollowups = followups.filter(followup => {
    const matchesStatus = filterStatus === 'all' || followup.status === filterStatus;
    const matchesType = filterType === 'all' || followup.type === filterType;
    return matchesStatus && matchesType;
  });

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Seguimientos</h1>
            <p className="text-sm text-gray-500 mt-1">Gestión de actividades y tareas comerciales</p>
          </div>
          <button
            onClick={() => setShowCreateModal(true)}
            className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-lg hover:shadow-lg transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-add-line text-lg"></i>
            Nuevo Seguimiento
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Total Seguimientos</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{followups.length}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-task-line text-2xl text-[#2F80ED]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Pendientes</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{followups.filter(f => f.status === 'Pendiente').length}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-time-line text-2xl text-[#EAB308]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Completados</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{followups.filter(f => f.status === 'Completado').length}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-checkbox-circle-line text-2xl text-[#10B981]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Vencidos</p>
                <p className="text-2xl font-bold text-[#0A2A43] mt-1">{followups.filter(f => f.status === 'Vencido').length}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-alert-line text-2xl text-[#EF4444]"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg p-4 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer"
              >
                <option value="all">Todos los estados</option>
                <option value="Pendiente">Pendiente</option>
                <option value="Completado">Completado</option>
                <option value="Vencido">Vencido</option>
              </select>
            </div>
            <div>
              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer"
              >
                <option value="all">Todos los tipos</option>
                <option value="Llamada">Llamada</option>
                <option value="Reunión">Reunión</option>
                <option value="Email">Email</option>
              </select>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#EAF2F8]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Tipo</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Cliente</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Oportunidad</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Descripción</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Responsable</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Fecha Límite</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Estado</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredFollowups.map((followup) => (
                  <tr key={followup.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                          <i className={`${getTypeIcon(followup.type)} text-[#2F80ED]`}></i>
                        </div>
                        <span className="text-sm font-medium text-[#0A2A43]">{followup.type}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{followup.client}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{followup.opportunity}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{followup.description}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{followup.responsible}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-[#0A2A43]">{followup.dueDate}</p>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(followup.status)}`}>
                        {followup.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => {
                            setSelectedFollowup(followup);
                            setShowDetailModal(true);
                          }}
                          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-[#EAF2F8] text-[#2F80ED] transition-colors cursor-pointer"
                          title="Ver detalle"
                        >
                          <i className="ri-eye-line text-lg"></i>
                        </button>
                        {followup.status === 'Pendiente' && (
                          <button
                            className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-green-50 text-green-600 transition-colors cursor-pointer"
                            title="Marcar completado"
                          >
                            <i className="ri-checkbox-circle-line text-lg"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Create Modal */}
        {showCreateModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-[#0A2A43]">Nuevo Seguimiento</h2>
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl text-gray-500"></i>
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Cliente *</label>
                    <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer">
                      <option>Seleccionar cliente</option>
                      <option>Importadora del Pacífico S.A.</option>
                      <option>Exportadora Central</option>
                      <option>Global Trade Solutions</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Oportunidad</label>
                    <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer">
                      <option>Seleccionar oportunidad</option>
                      <option>Importación Maquinaria Industrial</option>
                      <option>Exportación Textiles</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Tipo de Actividad *</label>
                    <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer">
                      <option>Llamada</option>
                      <option>Reunión</option>
                      <option>Email</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#0A2A43] mb-1">Fecha Límite *</label>
                    <input type="date" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0A2A43] mb-1">Responsable *</label>
                  <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm cursor-pointer">
                    <option>Juan Delgado</option>
                    <option>María López</option>
                    <option>Carlos Méndez</option>
                    <option>Ana Rodríguez</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0A2A43] mb-1">Descripción *</label>
                  <textarea rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent text-sm resize-none"></textarea>
                </div>
              </div>
              <div className="sticky bottom-0 bg-gray-50 px-6 py-4 flex items-center justify-end gap-3 border-t border-gray-200">
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cancelar
                </button>
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  Crear Seguimiento
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Detail Modal */}
        {showDetailModal && selectedFollowup && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-[#0A2A43]">Detalle del Seguimiento</h2>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl text-gray-500"></i>
                </button>
              </div>
              <div className="p-6 space-y-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                    <i className={`${getTypeIcon(selectedFollowup.type)} text-2xl text-[#2F80ED]`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0A2A43]">{selectedFollowup.type}</h3>
                    <p className="text-sm text-gray-500">{selectedFollowup.id}</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Cliente</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedFollowup.client}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Oportunidad</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedFollowup.opportunity}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Responsable</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedFollowup.responsible}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Fecha Límite</p>
                    <p className="text-sm font-medium text-[#0A2A43]">{selectedFollowup.dueDate}</p>
                  </div>
                  <div className="col-span-2">
                    <p className="text-sm text-gray-500 mb-1">Estado</p>
                    <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(selectedFollowup.status)}`}>
                      {selectedFollowup.status}
                    </span>
                  </div>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Descripción</p>
                  <p className="text-sm text-[#0A2A43]">{selectedFollowup.description}</p>
                </div>
              </div>
              <div className="sticky bottom-0 bg-gray-50 px-6 py-4 flex items-center justify-end gap-3 border-t border-gray-200">
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cerrar
                </button>
                {selectedFollowup.status === 'Pendiente' && (
                  <button className="px-4 py-2 bg-gradient-to-r from-[#10B981] to-[#059669] text-white rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                    Marcar como Completado
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}